export const onlyDigits = value => (value || '').replace(/\D/g, '');

export const formatCEP = value => {
  const digits = onlyDigits(value).slice(0, 8);

  if (digits.length !== 8) return digits;

  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
};

export const toNumberOrNull = value => {
  if (value === null || value === undefined || value === '') return null;

  const parsed = Number(value);

  return Number.isFinite(parsed) ? parsed : null;
};

export const normalizeLatLng = value => {
  const lat = toNumberOrNull(value?.lat);
  const lng = toNumberOrNull(value?.lng);

  if (lat === null || lng === null) return null;

  return { lat, lng };
};

export const readComponentText = (component, short = false) => {
  if (!component) return '';

  if (short) {
    return component.short_name || component.shortText || '';
  }

  return component.long_name || component.longText || '';
};

export const getAddressComponent = (
  components = [],
  types = [],
  { short = false } = {}
) => {
  const match = components.find(component =>
    types.some(type => (component.types || []).includes(type))
  );

  return match ? readComponentText(match, short) : '';
};

export const parseAddressComponents = (
  components = [],
  formattedAddress = ''
) => ({
  cep: formatCEP(getAddressComponent(components, ['postal_code'])),
  street_name: getAddressComponent(components, ['route']),
  number: getAddressComponent(components, ['street_number']),
  neighborhood: getAddressComponent(components, [
    'sublocality_level_1',
    'sublocality',
    'neighborhood',
  ]),
  city: getAddressComponent(components, [
    'locality',
    'administrative_area_level_2',
    'administrative_area_level_3',
  ]),
  state: getAddressComponent(components, ['administrative_area_level_1'], {
    short: true,
  }),
  formatted_address: formattedAddress || '',
});

export const formatResolvedAddressLabel = address => {
  const parts = [
    address.street_name,
    address.number && address.number !== 'sn' ? address.number : '',
    address.neighborhood,
    address.city,
    address.state,
    address.cep,
  ].filter(Boolean);

  return parts.join(', ');
};

export const extractLatLng = event => {
  if (event?.detail?.latLng) {
    return event.detail.latLng;
  }

  if (!event?.latLng) return null;

  if (typeof event.latLng.toJSON === 'function') {
    return event.latLng.toJSON();
  }

  if (
    typeof event.latLng.lat === 'function' &&
    typeof event.latLng.lng === 'function'
  ) {
    return {
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    };
  }

  return event.latLng;
};

export const pickGeocodeResults = (
  strictResponse,
  countryOnlyResponse,
  cepOnlyResponse
) => {
  if (strictResponse?.results?.length) {
    return strictResponse.results;
  }

  if (countryOnlyResponse?.results?.length) {
    return countryOnlyResponse.results;
  }

  if (cepOnlyResponse?.results?.length) {
    return cepOnlyResponse.results;
  }

  return [];
};
